import { Button } from "react-aria-components"
import { modalSignal } from "./ModalContainer"
import infoIcon from "../../../assets/icons/icon-exclamation-red.svg"
import destructiveIcon from "../../../assets/icons/icon-exclamation-red.svg"
import LoadingButton from "../LoadingButton"
import { useState } from "react"
import InputText from "../../lib/inputs/InputText";
import { httpDelete } from "../../../modules/Backend"
import { HttpStatusCode } from 'axios';

interface IRemoveModal {
    heading: string,
    information: string,
    textLabel: string,
    expectedConfirmationValue: string,
    ContinueFunc: Function,
    cancelFunc?: Function
    type?: ConfirmType,
    autoClose?: boolean | null | undefined,
    removeId: string,
    removeEntity: string
}

export enum ConfirmType {
    Info = 1,
    Destructive
}

const iconMap = {
    [ConfirmType.Info]: infoIcon,
    [ConfirmType.Destructive]: destructiveIcon
};

export default function RemoveModal({ heading, information, textLabel, expectedConfirmationValue, removeId, removeEntity, ContinueFunc, type, cancelFunc, autoClose }: IRemoveModal) {
    const [loading, setLoading] = useState<boolean>(false);
    const [confirmationValue, setConfirmationValue] = useState<string>("");

    async function handleContinue() {
        setLoading(true);
        const values = { id: removeId, ConfirmationValue: confirmationValue };
        const response = await httpDelete(`api/${removeEntity}/delete`, values);
        if (response.status === HttpStatusCode.Ok) {
            await ContinueFunc();
            setLoading(false);
            if (autoClose == undefined || autoClose === null || autoClose === true) {
                modalSignal.value = undefined;
            }
            // Delay reload so the success toast from httpDelete is visible
            setTimeout(() => window.location.reload(), 800);
        } else {
            await ContinueFunc();
            setLoading(false);
        }
    }

    function handleCancel() {
        modalSignal.value = undefined;
        if (cancelFunc) {
            cancelFunc();
        }
    }

    function resolveIcon(): string {
        return iconMap[type ?? ConfirmType.Info];
    }

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        setConfirmationValue(e.target.value);
    }

    return (
        <div className="display--flex flex__direction--column alignItems--center gap--xs">
            <img src={resolveIcon()} />
            <h1>{heading}</h1>
            <p className="textAlign--center whitespace--pre-line">{information}</p>
            <InputText className="autocomplete__input" required={false} label={textLabel} onChangeText={handleChange} value={confirmationValue} placeholder={''} />
            <p className="textDecoration--italics">{expectedConfirmationValue}</p>
            <div className="margin__top--xs display--flex gap--xs">
                <Button className=" button button--large button--secondary button--with-icon" onPress={handleCancel} isDisabled={loading}>
                    <p className="button-text">Cancel</p>
                </Button>
                <LoadingButton className="button button--large button--primary button--with-icon"
                    onPress={handleContinue}
                    buttonText="Confirm"
                    loadingText="Confirming"
                    isDisabled={loading || !confirmationValue}
                    isLoading={loading}>
                    <></>
                </LoadingButton>
            </div>
        </div>)
}
